export { default as IndexTableBody } from './IndexTableBody';
